// extracted by mini-css-extract-plugin
export default {"wrapper":"MessagesList_wrapper__FQ3iF","messages":"MessagesList_messages__j+4yD"};